import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
* @module table/tablecaption/tablecaptionui
*/
import { Plugin, icons } from 'ckeditor5/src/core.js';
import { ButtonView } from 'ckeditor5/src/ui.js';
import { getCaptionFromModelSelection } from './utils.js';
/**
  * The table caption UI plugin. It introduces the `'toggleTableCaption'` UI button.
  */
var TableCaptionUI = /*#__PURE__*/function (_Plugin) {
  _inherits(TableCaptionUI, _Plugin);
  var _super = _createSuper(TableCaptionUI);
  function TableCaptionUI() {
    _classCallCheck(this, TableCaptionUI);
    return _super.apply(this, arguments);
  }
  _createClass(TableCaptionUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;
      var editor = this.editor;
      var editingView = editor.editing.view;
      var t = editor.t;
      editor.ui.componentFactory.add('toggleTableCaption', function (locale) {
        var command = editor.commands.get('toggleTableCaption');
        var view = new ButtonView(locale);
        view.set({
          icon: icons.caption,
          tooltip: true,
          isToggleable: true
        });
        view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
        view.bind('label').to(command, 'value', function (value) {
          return value ? t('Toggle caption off') : t('Toggle caption on');
        });
        _this.listenTo(view, 'execute', function () {
          editor.execute('toggleTableCaption', {
            focusCaptionOnShow: true
          });
          // Scroll to the selection and highlight the caption if the caption showed up.
          if (command.value) {
            var modelCaptionElement = getCaptionFromModelSelection(editor.model.document.selection);
            var figcaptionElement = editor.editing.mapper.toViewElement(modelCaptionElement);
            if (!figcaptionElement) {
              return;
            }
            editingView.scrollToTheSelection();
            editingView.change(function (writer) {
              writer.addClass('table__caption_highlighted', figcaptionElement);
            });
          }
          editor.editing.view.focus();
        });
        return view;
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableCaptionUI';
    }
  }]);
  return TableCaptionUI;
}(Plugin);
export { TableCaptionUI as default };